export const UPDATE_SETTING = 'UPDATE_SETTING';
export const UPDATE_MENU_KEY = 'UPDATE_MENU_KEY';
export const UPDATE_TAB_GROUP = 'UPDATE_TAB_GROUP';
